import { LOCAL_STORAGE } from "../../constants";
import { getLocalStorageItem } from "../localStorage";
import { capitalize } from "../misc";

export function logsDataCompiler(data = []) {
  let finalData = [];
  data.forEach((obj) => {
    let logsData = {
      id: obj.id,
      url: obj.id,
      date: obj.date || 'N/A',
      total_quantity: obj.total_quantity || 0,
      total_body_produced: obj.total_body_produced || 0,
      total_rib_produced: obj.total_rib_produced || 0,
      total_quantity_produced: obj.total_quantity_produced || 0,
      total_damages: obj.total_damages || 0,
      status: capitalize(obj.status) || 'N/A',
      invoice_number: obj.invoice_number || 'N/A',
      data: obj,
    };
    finalData.push(logsData);
  });
  return finalData;
}

export function logDetailBox(log) {
  const vendorType = getLocalStorageItem(LOCAL_STORAGE.VENDOR_TYPE);

  let detailBoxData = [
    { name: 'Invoice No', col: 1, data: log?.invoice_number || 'N/A' },
    { name: 'Date', col: 1, data: log?.date || 'N/A' },
    { name: 'Status', col: 1, data: capitalize(log?.status) || 'N/A' },
    { name: 'Total Qty', col: 2, data: log?.total_quantity || 0 },
    { name: 'Total Damages', col: 2, data: log?.total_damages || 0 },
    { name: 'Total Qty Produced', col: 2, data: log?.total_quantity_produced || 0 }
  ];

  if (vendorType === 'fabric') {
    detailBoxData.push(
      { name: 'Total Body Produced', col: 2, data: log?.total_body_produced || 0 },
      { name: 'Total Rib Produced', col: 2, data: log?.total_rib_produced || 0 },
    );
  }

  return detailBoxData;
}


export function logLinesDataCompiler(data = []) {
  let finalData = [];
  data.forEach((obj) => {
    let logsData = {
      id: obj.id,
      date: obj.date || 'N/A',
      lot: obj.lot || 'N/A',
      quantity: obj.quantity || 0,
      damage_quantity: obj.damage_quantity || 0,
      message: obj.message || 'N/A',
      status: capitalize(obj.status) || 'N/A',
      product: obj.product_id?.display_name || 'N/A',
      size: obj.product_id?.variant_size || 'N/A',
      color: obj.product_id?.variant_color || 'N/A',
      invoice_number: obj.invoice_number || 'N/A',
      data: obj,
    };
    finalData.push(logsData);
  });
  return finalData;
}